/* mm-abo-original-v1.js
 *
 * 29.08.2026, feste Regel von Mert: Das bestaetigte Abo-Design wieder exakt
 * unter der Sortenauswahl zeigen. Die inzwischen entfernte Shopify-
 * Subscriptions-App lieferte frueher das Markup; die sieben echten Selling
 * Plans bestehen weiter. Diese Datei baut nur die historische Darstellung
 * wieder auf und schreibt die jeweils echte Selling-Plan-ID in das Kauf-
 * formular. Sie erhoeht niemals die Warenkorbmenge, um Laufzeiten zu
 * simulieren.
 */
(function () {
  'use strict';

  if (!/^\/products\//.test(window.location.pathname)) return;

  var BADGES = { 3: 'BESTSELLER', 6: 'HALBJAHRES-HIT', 12: 'JAHRES-VORTEIL' };
  var EURO = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2, maximumFractionDigits: 2
  });
  var state = { abo: false, open: false, planIndex: 0, product: null, plans: [] };
  var holdTimer = 0;
  var shineObserver = null;
  var flavorCycleObserver = null;
  var flavorCycleAnchor = null;
  var flavorCycleInView = false;
  var flavorCycleVisibilityBound = false;

  function money(value) {
    return '€' + EURO.format(value);
  }

  function assetBase() {
    var scripts = document.scripts;
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].src || '';
      if (/\/mm-abo-original-v1\.js(?:\?|$)/.test(src)) {
        return src.slice(0, src.lastIndexOf('/') + 1);
      }
    }
    return '/cdn/shop/assets/';
  }

  function productKey(title) {
    var text = (window.location.pathname + ' ' + document.title + ' ' + (title || '')).toLowerCase();
    if (/magic-fruit|magic fruit|florea/.test(text)) return 'florea';
    if (/zero-termo|zerotermo|zero termo|nuss|creamy|pro.?milk/.test(text)) return 'nuss';
    if (/erdbeer|strawberry/.test(text)) return 'strawberry';
    return 'standard';
  }

  function isSetPage(title) {
    var text = (window.location.pathname + ' ' + document.title + ' ' + (title || '')).toLowerCase();
    return /(^|[-\s])(set|sets|2er|3er|4er|5er|6er|bundle|paket|duo|trio)([-\s]|$)/.test(text);
  }

  function planData(plan) {
    var name = String(plan.name || '');
    var year = /1\s*Jahr/i.test(name);
    var monthMatch = name.match(/(\d+)\s*Monat/i);
    var deliveryMatch = name.match(/(\d+)\s*Liefer/i);
    var months = year ? 12 : (monthMatch ? parseInt(monthMatch[1], 10) : 1);
    var deliveries = deliveryMatch ? parseInt(deliveryMatch[1], 10) : months;
    var adjustment = (plan.price_adjustments || [])[0] || {};
    var discount = adjustment.value_type === 'percentage' ? Number(adjustment.value) || 0 : 0;
    return {
      id: String(plan.id || ''),
      months: months,
      deliveries: deliveries,
      discount: discount,
      termPlan: /Monat|Jahr/i.test(name),
      title: year ? '1 Jahr' : months + (months === 1 ? ' Monat' : ' Monate')
    };
  }

  function style() {
    if (document.getElementById('mm-abo-original-style-v1')) return;
    var css = [
      '#mmAboOriginal{--mmInk:#151013;--mmMuted:#746f72;--mmLine:#d3d0d1;--mmAccent:#e5142a;',
        '--mmGlassSolid:#fbf8f9;--mmGlassEdge:rgba(255,255,255,.92);',
        'width:100%;max-width:100%;margin:23px 0 18px;padding:0;color:var(--mmInk);',
        'font-family:"MM Poppins","Bricolage Grotesque","Manrope",system-ui,sans-serif}',
      '#mmAboOriginal,#mmAboOriginal *{box-sizing:border-box}',
      '#mmAboOriginal button{font:inherit}',

      /* Exakt die historische Ueberschrift mit Linien links und rechts. */
      '#mmAboOriginal .mmAOHeading{display:grid;grid-template-columns:minmax(20px,1fr) auto minmax(20px,1fr);',
        'align-items:center;gap:12px;margin:0 0 18px}',
      '#mmAboOriginal .mmAOHeading:before,#mmAboOriginal .mmAOHeading:after{content:"";height:1px;background:#bdb9bb}',
      '#mmAboOriginal .mmAOHeading h2{margin:0;color:var(--mmInk);font-family:"MM Poppins",',
        '"Bricolage Grotesque",sans-serif;font-size:clamp(.78rem,3.2vw,.94rem);font-weight:900;',
        'line-height:1.12;letter-spacing:-.035em;white-space:nowrap;text-transform:none!important}',

      '#mmAboOriginal .mmAOCards{display:grid;grid-template-columns:1fr;gap:18px}',
      '#mmAboOriginal .mmAOCard{position:relative;width:100%;min-width:0;border:1.5px solid var(--mmLine);',
        'border-radius:18px;background:#fff;color:var(--mmInk);overflow:visible;',
        'transition:border-color .22s ease,box-shadow .22s ease}',
      '#mmAboOriginal .mmAOCard[data-selected="true"]{border:2.5px solid var(--mmInk);',
        'box-shadow:0 4px 15px rgba(21,16,19,.06)}',
      '#mmAboOriginal .mmAOCard:focus-visible{outline:3px solid var(--mmAccent);outline-offset:3px}',
      '#mmAboOriginal .mmAOCardMain{position:relative;display:grid;grid-template-columns:76px minmax(0,1fr);',
        'align-items:center;column-gap:11px;min-height:86px;padding:11px 14px;cursor:pointer;border-radius:16px}',
      '#mmAboOriginal .mmAOCard[data-selected="true"] .mmAOCardMain{padding:10px 13px}',

      /* Echte freigestellte Produktsticks, immer contain und nie beschnitten. */
      '#mmAboOriginal .mmAOSticks{position:relative;width:76px;height:64px;align-self:center}',
      '#mmAboOriginal .mmAOStick{position:absolute;top:50%;left:50%;display:block;width:31px;height:62px;',
        'object-fit:contain;object-position:center;transform:translate(-50%,-50%);filter:drop-shadow(0 3px 3px rgba(21,16,19,.10))}',
      '#mmAboOriginal [data-kind="abo"] .mmAOStick:nth-child(1){transform:translate(calc(-50% - 17px),-50%)}',
      '#mmAboOriginal [data-kind="abo"] .mmAOStick:nth-child(2){z-index:2;transform:translate(-50%,-50%)}',
      '#mmAboOriginal [data-kind="abo"] .mmAOStick:nth-child(3){transform:translate(calc(-50% + 17px),-50%)}',
      '#mmAboOriginal .mmAOName{display:block;margin:0;color:var(--mmInk);font-family:"MM Poppins",',
        '"Bricolage Grotesque",sans-serif;font-size:.96rem;font-weight:900;line-height:1.12;letter-spacing:-.025em}',
      '#mmAboOriginal .mmAOPrice{display:block;margin:8px 0 0;color:var(--mmInk);font-family:"MM Poppins",',
        '"Bricolage Grotesque",sans-serif;font-size:1.12rem;font-weight:900;line-height:1;letter-spacing:-.025em;white-space:nowrap}',
      '#mmAboOriginal .mmAOSub{display:block;margin:5px 0 0;color:#6d686b;font-family:"Manrope",system-ui,sans-serif;',
        'font-size:.69rem;font-weight:700;line-height:1.3}',

      '#mmAboOriginal .mmAOBadge{position:absolute;z-index:5;top:-17px;right:9px;padding:8px 15px;',
        'border:0;border-radius:999px;background-color:var(--mmInk);color:#fff;',
        'background-image:linear-gradient(115deg,transparent 0 38%,rgba(255,255,255,.34) 50%,transparent 62% 100%);',
        'background-size:235% 100%;background-position:180% 0;background-repeat:no-repeat;',
        'box-shadow:0 4px 12px rgba(21,16,19,.22),inset 0 1px 0 rgba(255,255,255,.26);',
        'font-family:"MM Poppins","Bricolage Grotesque",sans-serif;font-size:.72rem;font-weight:900;',
        'line-height:1;letter-spacing:.035em;white-space:nowrap;text-transform:uppercase}',
      '#mmAboOriginal.mmAOSeen .mmAOBadge{animation:mmAOShine 4.6s linear infinite}',
      '@keyframes mmAOShine{0%{background-position:180% 0}62%,100%{background-position:-70% 0}}',

      /* Die Laufzeitwahl sitzt wie im bestaetigten Bild IN der Abo-Karte. */
      '#mmAboOriginal .mmAOSelector{display:grid;grid-template-columns:auto minmax(0,1fr) 10px;align-items:center;',
        'gap:9px;width:calc(100% - 20px);min-height:43px;margin:0 10px 10px;padding:9px 11px;',
        'border:1.5px solid #b8b4b6;border-radius:16px;background:#fff;color:var(--mmInk);cursor:pointer;text-align:left}',
      '#mmAboOriginal .mmAOSelector:hover{border-color:#6f696c}',
      '#mmAboOriginal .mmAOSelector:focus-visible{outline:3px solid var(--mmAccent);outline-offset:2px}',
      '#mmAboOriginal .mmAOSelectorTitle{font-family:"MM Poppins","Bricolage Grotesque",sans-serif;',
        'font-size:.73rem;font-weight:900;line-height:1.2;white-space:nowrap}',
      '#mmAboOriginal .mmAOSelectorValue{justify-self:end;color:#696467;font-family:"MM Poppins",',
        '"Bricolage Grotesque",sans-serif;font-size:.67rem;font-weight:800;line-height:1.2;white-space:nowrap}',
      '#mmAboOriginal .mmAOChevron{width:8px;height:8px;margin:0 1px 4px 0;border-right:2.5px solid var(--mmInk);',
        'border-bottom:2.5px solid var(--mmInk);transform:rotate(45deg);transition:transform .24s ease}',
      '#mmAboOriginal[data-open="true"] .mmAOChevron{margin:4px 1px 0 0;transform:rotate(225deg)}',

      '#mmAboOriginal .mmAOPanelWrap{display:grid;grid-template-rows:0fr;margin:0 10px;opacity:0;',
        'transition:grid-template-rows .38s cubic-bezier(.22,.61,.36,1),opacity .28s ease,margin .38s ease}',
      '#mmAboOriginal[data-open="true"] .mmAOPanelWrap{grid-template-rows:1fr;margin:0 10px 10px;opacity:1}',
      '#mmAboOriginal .mmAOPanelClip{min-height:0;overflow:clip}',
      '#mmAboOriginal .mmAOPanel{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:7px;padding:3px 0 1px}',
      '#mmAboOriginal .mmAOPlan{position:relative;display:flex;flex-direction:column;align-items:flex-start;',
        'min-height:98px;padding:12px 10px 10px;border:1.5px solid #dedadc;border-radius:16px;',
        'background:#fff;color:var(--mmInk);cursor:pointer;text-align:left;overflow:clip;',
        'transition:border-color .2s ease,background .2s ease,transform .2s ease}',
      '#mmAboOriginal .mmAOPlan:hover{border-color:#8e888b;transform:translateY(-1px)}',
      '#mmAboOriginal .mmAOPlan[data-active="true"]{border:2px solid var(--mmInk);padding:11px 9px 9px;background:#f7edef}',
      '#mmAboOriginal .mmAOPlan[data-badge]{padding-top:40px}',
      '#mmAboOriginal .mmAOPlan[data-active="true"][data-badge]{padding-top:39px}',
      '#mmAboOriginal .mmAOPlan[data-badge]:before{content:attr(data-badge);position:absolute;top:8px;right:8px;',
        'max-width:calc(100% - 14px);padding:6px 10px;border-radius:999px;background-color:#151013;color:#fff;',
        'background-image:linear-gradient(115deg,transparent 0 38%,rgba(255,255,255,.38) 50%,transparent 62% 100%);',
        'background-size:235% 100%;background-position:180% 0;background-repeat:no-repeat;',
        'font-family:"Manrope",system-ui,sans-serif;font-size:.62rem;font-weight:900;line-height:1;',
        'letter-spacing:.045em;white-space:nowrap;overflow:clip;text-overflow:ellipsis;will-change:background-position}',
      '#mmAboOriginal .mmAOPlan[data-months="6"]:before{background-color:#ff4b7e;color:#151013}',
      '#mmAboOriginal .mmAOPlan[data-months="12"]:before{background-color:#e5142a;color:#fff}',
      '#mmAboOriginal.mmAOSeen[data-open="true"] .mmAOPlan[data-badge]:before{animation:mmAOPlanShine 4.8s linear infinite}',
      '#mmAboOriginal.mmAOSeen[data-open="true"] .mmAOPlan[data-months="6"]:before{animation-delay:-3.2s}',
      '#mmAboOriginal.mmAOSeen[data-open="true"] .mmAOPlan[data-months="12"]:before{animation-delay:-1.6s}',
      '@keyframes mmAOPlanShine{0%{background-position:180% 0}28%,100%{background-position:-70% 0}}',
      '#mmAboOriginal .mmAOPlanTitle{font-family:"MM Bebas","Bebas Neue",Impact,sans-serif;',
        'font-size:1.06rem;font-weight:400;line-height:1;letter-spacing:.02em;text-transform:uppercase}',
      '#mmAboOriginal .mmAOPlanDiscount{display:flex;align-items:baseline;gap:4px;margin-top:6px;color:#6e6469;',
        'font-family:"Manrope",system-ui,sans-serif;font-size:.55rem;font-weight:700;line-height:1}',
      '#mmAboOriginal .mmAOPlanDiscount b{display:inline-flex;align-items:baseline;color:var(--mmInk);font-family:"MM Bebas","Bebas Neue",Impact,sans-serif;',
        'font-size:1.48rem;font-weight:400;line-height:.86;font-variant-numeric:tabular-nums}',
      '#mmAboOriginal .mmAONumber{display:inline-flex;align-items:baseline;font:inherit;line-height:inherit}',
      '#mmAboOriginal .mmAORollDigit{display:inline-block;height:.9em;overflow:hidden;line-height:.9;vertical-align:baseline}',
      '#mmAboOriginal .mmAORollTrack{display:block;font:inherit;font-style:normal;line-height:.9;transform:translateY(0);will-change:transform}',
      '#mmAboOriginal .mmAORollTrack span{display:block;height:.9em;line-height:.9}',
      '#mmAboOriginal.mmAOPopPercents .mmAORollTrack{transform:translateY(var(--mmShift));',
        'transition:transform .55s cubic-bezier(.22,.61,.36,1);transition-delay:var(--mmDelay)}',
      '#mmAboOriginal .mmAOPercentSign{display:inline-block}',
      '#mmAboOriginal .mmAOPlanMeta{display:block;margin-top:auto;padding-top:7px;color:#6e696b;',
        'font-family:"Manrope",system-ui,sans-serif;font-size:.56rem;font-weight:650;line-height:1.25}',
      '#mmAboOriginal .mmAOPlanPrice{display:block;margin-top:3px;color:#817b7e;font-family:"Manrope",',
        'system-ui,sans-serif;font-size:.54rem;font-weight:700;line-height:1.2}',
      '#mmAboOriginal .mmAOPlan[data-months="12"]{grid-column:1/-1;min-height:88px}',

      '#mmAboOriginal .mmAONote{margin:14px 8px 0;color:#7a7477;font-family:"Manrope",system-ui,sans-serif;',
        'font-size:.68rem;font-weight:500;line-height:1.42;text-align:center}',

      '@media(min-width:700px){#mmAboOriginal .mmAOCards{grid-template-columns:repeat(2,minmax(0,1fr));gap:9px;align-items:start}',
        '#mmAboOriginal .mmAOCard[data-kind="abo"]{display:contents}',
        '#mmAboOriginal .mmAOCard[data-kind="abo"] .mmAOCardMain{grid-column:2;grid-row:1;border:1.5px solid var(--mmLine);border-radius:18px;background:#fff}',
        '#mmAboOriginal .mmAOCard[data-kind="abo"][data-selected="true"] .mmAOCardMain{border:2.5px solid var(--mmInk);box-shadow:0 4px 15px rgba(21,16,19,.06)}',
        '#mmAboOriginal .mmAOCard[data-kind="abo"]:focus-visible .mmAOCardMain{outline:3px solid var(--mmAccent);outline-offset:3px}',
        '#mmAboOriginal .mmAOCard[data-kind="abo"] .mmAOSelector{grid-column:1/-1;grid-row:2;width:100%;margin:0}',
        '#mmAboOriginal .mmAOCard[data-kind="abo"] .mmAOPanelWrap{grid-column:1/-1;grid-row:3;margin-left:0;margin-right:0}',
        '#mmAboOriginal[data-open="true"] .mmAOCard[data-kind="abo"] .mmAOPanelWrap{margin-left:0;margin-right:0}',
        '#mmAboOriginal .mmAOCardMain{grid-template-columns:56px minmax(0,1fr);min-height:106px;padding:10px}',
        '#mmAboOriginal .mmAOCard[data-selected="true"] .mmAOCardMain{padding:9px}',
        '#mmAboOriginal .mmAOSticks{width:56px;height:67px}',
        '#mmAboOriginal .mmAOStick{width:27px;height:65px}',
        '#mmAboOriginal [data-kind="abo"] .mmAOStick:nth-child(1){transform:translate(calc(-50% - 13px),-50%)}',
        '#mmAboOriginal [data-kind="abo"] .mmAOStick:nth-child(3){transform:translate(calc(-50% + 13px),-50%)}',
        '#mmAboOriginal .mmAOName{font-size:.78rem}',
        '#mmAboOriginal .mmAOPrice{font-size:.96rem}',
        '#mmAboOriginal .mmAOSub{font-size:.58rem}',
        '#mmAboOriginal .mmAOSelector{min-height:36px;margin:0 9px 9px;padding:7px 9px}',
        '#mmAboOriginal .mmAOSelectorTitle{font-size:.62rem}',
        '#mmAboOriginal .mmAOSelectorValue{font-size:.56rem}',
        '#mmAboOriginal .mmAOPanel{grid-template-columns:repeat(3,minmax(0,1fr))}',
        '#mmAboOriginal .mmAOPlan[data-months="12"]{grid-column:1/-1}',
        '#mmAboOriginal .mmAONote{grid-column:1/-1}}',
      '@media(max-width:370px){#mmAboOriginal .mmAOHeading{gap:8px}',
        '#mmAboOriginal .mmAOHeading h2{font-size:.74rem}',
        '#mmAboOriginal .mmAOCardMain{grid-template-columns:68px minmax(0,1fr);padding-left:10px;padding-right:10px}',
        '#mmAboOriginal .mmAOPrice{font-size:1.02rem}',
        '#mmAboOriginal .mmAOSelector{grid-template-columns:auto minmax(0,1fr) 9px}',
        '#mmAboOriginal .mmAOSelectorValue{font-size:.61rem}}',

      /* Dezente Web-Glasoptik: gleiche historische Struktur, aber mit echter
         Transparenz, Hintergrundweichzeichnung und innerer Lichtkante. */
      '#mmAboOriginal .mmAOCards{position:relative;isolation:isolate}',
      '#mmAboOriginal .mmAOCards:before{content:"";position:absolute;z-index:-1;inset:-10px -8px;',
        'border-radius:26px;pointer-events:none;background:radial-gradient(circle at 18% 12%,rgba(255,75,126,.14),transparent 38%),',
        'radial-gradient(circle at 88% 82%,rgba(229,20,42,.09),transparent 34%);filter:blur(13px)}',
      '#mmAboOriginal .mmAOCard,#mmAboOriginal .mmAOSelector,#mmAboOriginal .mmAOPlan{',
        'background:var(--mmGlassSolid);box-shadow:inset 0 1px 0 rgba(255,255,255,.92),',
        'inset 0 -1px 0 rgba(255,255,255,.46),0 12px 30px rgba(48,32,39,.08)}',
      '#mmAboOriginal .mmAOCard[data-selected="true"]{box-shadow:inset 0 1px 0 rgba(255,255,255,.95),',
        'inset 0 -1px 0 rgba(255,255,255,.48),0 14px 34px rgba(48,32,39,.12)}',
      '#mmAboOriginal .mmAOPlan[data-active="true"]{background:#f7edef;box-shadow:inset 0 1px 0 rgba(255,255,255,.94),',
        '0 10px 24px rgba(92,49,65,.10)}',
      '@media(min-width:700px){#mmAboOriginal .mmAOCard[data-kind="abo"] .mmAOCardMain{',
        'background:var(--mmGlassSolid);box-shadow:inset 0 1px 0 rgba(255,255,255,.92),',
        'inset 0 -1px 0 rgba(255,255,255,.46),0 12px 30px rgba(48,32,39,.08)}',
        '#mmAboOriginal .mmAOCard[data-kind="abo"][data-selected="true"] .mmAOCardMain{',
        'box-shadow:inset 0 1px 0 rgba(255,255,255,.95),inset 0 -1px 0 rgba(255,255,255,.48),',
        '0 14px 34px rgba(48,32,39,.12)}}',
      '@supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))){',
        '#mmAboOriginal .mmAOCard,#mmAboOriginal .mmAOSelector,#mmAboOriginal .mmAOPlan{',
        'background:linear-gradient(145deg,rgba(255,255,255,.82),rgba(255,255,255,.48)),rgba(255,255,255,.44);',
        '-webkit-backdrop-filter:blur(18px) saturate(145%);backdrop-filter:blur(18px) saturate(145%);',
        'border-color:rgba(190,180,185,.72)}',
        '#mmAboOriginal .mmAOPlan[data-active="true"]{background:linear-gradient(145deg,rgba(255,255,255,.82),',
        'rgba(255,238,243,.58)),rgba(247,237,239,.46)}',
        '@media(min-width:700px){#mmAboOriginal .mmAOCard[data-kind="abo"] .mmAOCardMain{',
        'background:linear-gradient(145deg,rgba(255,255,255,.82),rgba(255,255,255,.48)),rgba(255,255,255,.44);',
        '-webkit-backdrop-filter:blur(18px) saturate(145%);backdrop-filter:blur(18px) saturate(145%);',
        'border-color:rgba(190,180,185,.72)}}}',
      '@media(prefers-reduced-transparency:reduce){#mmAboOriginal .mmAOCards:before{display:none}',
        '#mmAboOriginal .mmAOCard,#mmAboOriginal .mmAOSelector,#mmAboOriginal .mmAOPlan,',
        '#mmAboOriginal .mmAOCard[data-kind="abo"] .mmAOCardMain{background:var(--mmGlassSolid)!important;',
        '-webkit-backdrop-filter:none!important;backdrop-filter:none!important}}',
      '@media(prefers-reduced-motion:reduce){#mmAboOriginal *,#mmAboOriginal *:before{animation:none!important;',
        'transition:none!important;transform:none!important}',
        '#mmAboOriginal.mmAOPopPercents .mmAORollTrack{transform:translateY(var(--mmShift))!important}}'
    ].join('');
    var node = document.createElement('style');
    node.id = 'mm-abo-original-style-v1';
    node.textContent = css;
    (document.head || document.documentElement).appendChild(node);
  }

  function flavorAnchor() {
    return document.querySelector('[id*="buy_box_connected_product_picker_EtdwKa"]') ||
      document.querySelector('.shopify-block[id*="connected_product_picker"]');
  }

  function flavorKind(href) {
    var value = String(href || '').toLowerCase();
    if (/magic-fruit|florea/.test(value)) return 'fruit';
    if (/zero-termo|zerotermo|nuss|creamy|pro-milk/.test(value)) return 'nuss';
    if (/erdbeer|strawberry/.test(value)) return 'strawberry';
    return '';
  }

  function flavorSymbol(kind) {
    if (kind === 'strawberry') return '<svg viewBox="0 0 48 48" aria-hidden="true"><path fill="#2f7d49" d="M16 14c2-5 5-7 8-7 1 3 1 5 0 7 3-3 6-4 9-3-1 4-4 6-8 7-4-1-7-2-9-4Z"/><path fill="#e5142a" d="M24 13c9 0 15 5 14 12-1 8-9 16-14 19-5-3-13-11-14-19-1-7 5-12 14-12Z"/><g fill="#ffd7a3"><circle cx="18" cy="24" r="1.2"/><circle cx="25" cy="21" r="1.2"/><circle cx="31" cy="25" r="1.2"/><circle cx="20" cy="31" r="1.2"/><circle cx="28" cy="33" r="1.2"/></g></svg>';
    if (kind === 'nuss') return '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M13 15c5-6 11-7 16-3" fill="none" stroke="#2f7d49" stroke-width="3" stroke-linecap="round"/><ellipse cx="19" cy="29" rx="8" ry="10" fill="#8eb34f" stroke="#4f8b3b" stroke-width="2"/><ellipse cx="31" cy="29" rx="8" ry="10" fill="#a6c866" stroke="#4f8b3b" stroke-width="2"/></svg>';
    return '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="19" cy="29" r="11" fill="#ff4b7e"/><circle cx="31" cy="29" r="9" fill="#e5142a"/><path d="M17 18c2-5 6-7 10-6-1 4-4 7-8 8m10-3c2-4 5-5 8-4-1 4-4 6-7 6" fill="#3f8d4f"/><path d="m25 7 2.2 4.2 4.8.7-3.5 3.4.8 4.8-4.3-2.3-4.3 2.3.8-4.8-3.5-3.4 4.8-.7L25 7Z" fill="#f4b942"/></svg>';
  }

  function decorateFlavors(anchor) {
    var links = anchor.querySelectorAll('a.connected_products__product');
    var labels = { strawberry: 'Erdbeere', nuss: 'Nuss', fruit: 'Fruit Premium' };
    for (var i = 0; i < links.length; i++) {
      var kind = flavorKind(links[i].getAttribute('href'));
      var container = links[i].querySelector('.connected_products__product__image_container');
      if (!kind || !container) continue;
      links[i].classList.add('mmFlavorChoice');
      links[i].style.setProperty('--mmFlavorRevealDelay', (i * 90) + 'ms');
      links[i].style.setProperty('--mmFlavorDriftDelay', (-i * .8) + 's');
      links[i].setAttribute('aria-label', labels[kind]);
      var image = container.querySelector('img');
      if (image) image.setAttribute('aria-hidden', 'true');
      if (!container.querySelector('.mmFlavorSymbol')) {
        var symbol = document.createElement('span');
        symbol.className = 'mmFlavorSymbol';
        symbol.innerHTML = flavorSymbol(kind);
        container.appendChild(symbol);
      }
      var title = links[i].querySelector('.connected_products__product__title');
      if (title) { title.classList.add('mmFlavorCaption'); title.textContent = labels[kind]; }
    }
  }

  function labelFlavors() {
    var anchor = flavorAnchor();
    if (!anchor) return false;
    decorateFlavors(anchor);
    anchor.classList.add('mmFlavorEntered');
    var title = anchor.querySelector('.connected_products__title');
    if (!title) return false;
    observeFlavorCycle(anchor);
    if (!document.getElementById('mm-sorten-label-style')) {
      var labelStyle = document.createElement('style');
      labelStyle.id = 'mm-sorten-label-style';
      labelStyle.textContent =
        '.connected_products__title.mmSortenLabel{display:none!important;margin:0!important}' +
        '.connected_products__products{display:flex!important;align-items:flex-start!important;justify-content:flex-start!important;gap:8px!important;padding-inline:0!important;margin-inline:0!important;box-sizing:border-box!important;overflow:visible!important}' +
        '.connected_products__product.mmFlavorChoice{position:relative!important;display:flex!important;flex:0 0 58px!important;width:58px!important;min-width:58px!important;min-height:57px!important;flex-direction:column!important;align-items:center!important;gap:5px!important;overflow:visible!important;color:#151013!important;opacity:0;transform:translate3d(-12px,5px,0);transition:opacity .48s ease,transform .62s cubic-bezier(.22,.61,.36,1)!important;transition-delay:var(--mmFlavorRevealDelay,0ms)!important}' +
        '.mmFlavorEntered .connected_products__product.mmFlavorChoice{opacity:1;transform:none}' +
        '.mmFlavorChoice .connected_products__product__image_container{position:relative!important;display:grid!important;place-items:center!important;width:42px!important;height:42px!important;padding:1px!important;border:1px solid #e7e3e5!important;border-radius:50%!important;overflow:hidden!important;background:#fff!important;box-shadow:0 2px 7px rgba(21,16,19,.08)!important;will-change:transform}' +
        '.mmFlavorChoice .connected_products__product__image_container:before,.mmFlavorChoice .connected_products__product__image_container:after{content:none!important}' +
        '.mmFlavorChoice .connected_products__product__image{position:absolute!important;z-index:1!important;inset:1px!important;width:calc(100% - 2px)!important;height:calc(100% - 2px)!important;border-radius:50%!important;object-fit:cover!important;opacity:0;pointer-events:none}' +
        '.mmFlavorChoice .mmFlavorSymbol{position:absolute;z-index:2;inset:1px;display:grid;place-items:center;border-radius:50%;background:#fff;pointer-events:none}' +
        '.mmFlavorChoice .mmFlavorSymbol svg{display:block;width:26px;height:26px}' +
        '.mmFlavorCycleVisible .mmFlavorChoice .connected_products__product__image{animation:mmFlavorProductCycle 3.2s cubic-bezier(.77,0,.175,1) infinite}' +
        '.mmFlavorCycleVisible .mmFlavorChoice .mmFlavorSymbol{animation:mmFlavorSymbolCycle 3.2s cubic-bezier(.77,0,.175,1) infinite}' +
        '.mmFlavorCycleVisible.mmFlavorEntered .mmFlavorChoice .connected_products__product__image_container{animation:mmFlavorDrift 4.8s ease-in-out infinite;animation-delay:var(--mmFlavorDriftDelay,0s)}' +
        '@keyframes mmFlavorProductCycle{0%,42%{opacity:0}50%,92%{opacity:1}100%{opacity:0}}@keyframes mmFlavorSymbolCycle{0%,42%{opacity:1}50%,92%{opacity:0}100%{opacity:1}}@keyframes mmFlavorDrift{0%,100%{transform:translate3d(0,0,0)}50%{transform:translate3d(0,-1px,0)}}' +
        '.mmFlavorChoice .connected_products__product__title.mmFlavorCaption{display:block!important;width:100%!important;position:static!important;inset:auto!important;order:2!important;transform:none!important;margin:0!important;padding:0!important;background:none!important;color:#5f5a5d!important;font-family:"Manrope",system-ui,sans-serif!important;font-size:.52rem!important;font-weight:750!important;line-height:1.15!important;text-align:center!important;white-space:nowrap!important;overflow:visible!important}' +
        '@media(prefers-reduced-motion:reduce){.connected_products__product.mmFlavorChoice{opacity:1!important;transform:none!important;transition:none!important}.mmFlavorChoice .connected_products__product__image,.mmFlavorChoice .mmFlavorSymbol,.mmFlavorChoice .connected_products__product__image_container{animation:none!important}}';
      (document.head || document.documentElement).appendChild(labelStyle);
    }
    title.classList.add('mmSortenLabel');
    title.setAttribute('aria-hidden', 'true');
    return true;
  }

  function syncFlavorCycle() {
    if (flavorCycleAnchor) flavorCycleAnchor.classList.toggle('mmFlavorCycleVisible', flavorCycleInView && !document.hidden);
  }

  function observeFlavorCycle(anchor) {
    if (!anchor || flavorCycleAnchor === anchor) return;
    if (flavorCycleObserver) flavorCycleObserver.disconnect();
    flavorCycleAnchor = anchor;
    flavorCycleInView = false;
    if (!flavorCycleVisibilityBound) { document.addEventListener('visibilitychange', syncFlavorCycle); flavorCycleVisibilityBound = true; }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { syncFlavorCycle(); return; }
    if ('IntersectionObserver' in window) {
      flavorCycleObserver = new IntersectionObserver(function (entries) { flavorCycleInView = !!(entries[0] && entries[0].isIntersecting); syncFlavorCycle(); }, { threshold: .22, rootMargin: '0px 0px -8% 0px' });
      flavorCycleObserver.observe(anchor);
    } else { flavorCycleInView = true; syncFlavorCycle(); }
  }

  function placementParent() {
    var anchor = flavorAnchor();
    return anchor && anchor.parentNode ? { parent: anchor.parentNode, before: anchor.nextSibling } : null;
  }

  function mainForm() {
    var buy = document.querySelector('span.buy-buttons-block') ||
      document.querySelector('[id*="buy_buttons_HCBiTi"]');
    return buy && buy.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form-component form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
  }

  function ensureSellingPlanField() {
    var form = mainForm();
    if (!form) return null;
    var field = form.querySelector('input[data-mm-abo-original-plan]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'selling_plan';
      field.setAttribute('data-mm-abo-original-plan', '1');
      form.appendChild(field);
    }
    return field;
  }

  function setSealPlan(plan) {
    var radios = document.querySelectorAll('input[name^="subs_type"]');
    var select = document.querySelector('select[name="subs_interval"],select.sls-select');
    if (!radios.length) return false;
    var wanted = null;
    for (var i = 0; i < radios.length; i++) {
      var once = String(radios[i].value || '').toLowerCase() === 'one_time';
      if ((state.abo && !once) || (!state.abo && once)) {
        if (!wanted) wanted = radios[i];
      }
    }
    if (select && state.abo && plan) {
      select.value = String(plan.id);
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (wanted && !wanted.checked) {
      wanted.checked = true;
      wanted.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function applyPlan() {
    var plan = state.plans[state.planIndex] || state.plans[0];
    var field = ensureSellingPlanField();
    if (!field || !plan) return;
    var sealLeads = setSealPlan(plan);
    field.value = sealLeads ? '' : (state.abo ? plan.id : '');
    field.disabled = sealLeads || !state.abo;
    if (!sealLeads && state.abo) {
      field.disabled = false;
      mainForm().appendChild(field);
    }
  }

  function buttonText() {
    var button = document.querySelector('span.buy-buttons-block button[name="add"]') ||
      document.querySelector('button[name="add"].add-to-cart-button');
    if (!button) return;
    var wanted = state.abo ? 'Abo in den Warenkorb' : 'In den Warenkorb';
    var textNodes = [];
    for (var i = 0; i < button.childNodes.length; i++) {
      if (button.childNodes[i].nodeType === 3 && button.childNodes[i].nodeValue.trim()) {
        textNodes.push(button.childNodes[i]);
      }
    }
    if (textNodes.length) textNodes[0].nodeValue = ' ' + wanted + ' ';
  }

  function hideDuplicateWidgets() {
    var selectors = [
      '.sealsubs-target-element', '.sealsubs-container', '.sls-purchase-options-container',
      '.shopify_subscriptions_app_container', '.mmSAWahl', '#mmAP',
      '[class*="kaching-subscription"]', '[class*="subi-subscription"]'
    ].join(',');
    var nodes = document.querySelectorAll(selectors);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].id === 'mmAboOriginal' || nodes[i].contains(document.getElementById('mmAboOriginal'))) continue;
      nodes[i].style.setProperty('display', 'none', 'important');
      nodes[i].setAttribute('aria-hidden', 'true');
    }
  }

  function rollNumberMarkup(value, planIndex) {
    var text = String(value);
    var html = '';
    for (var digitIndex = 0; digitIndex < text.length; digitIndex++) {
      var digit = text.charAt(digitIndex);
      if (!/[0-9]/.test(digit)) {
        html += '<span aria-hidden="true">' + digit + '</span>';
        continue;
      }
      var stack = '';
      for (var number = 0; number <= 9; number++) stack += '<span>' + number + '</span>';
      var shift = String(parseFloat((-Number(digit) * 0.9).toFixed(2))) + 'em';
      var delay = 140 + (planIndex * 100) + (digitIndex * 35);
      html += '<span class="mmAORollDigit" aria-hidden="true"><span class="mmAORollTrack" style="--mmShift:' +
        shift + ';--mmDelay:' + delay + 'ms">' + stack + '</span></span>';
    }
    return '<span class="mmAONumber" aria-label="' + text + '">' + html + '</span>';
  }

  function render() {
    var root = document.getElementById('mmAboOriginal');
    if (!root) return;
    var product = state.product;
    var plan = state.plans[state.planIndex] || state.plans[0];
    var basePrice = product.variants[0].price / 100;
    var planPrice = basePrice * (1 - plan.discount / 100);
    root.setAttribute('data-open', String(state.open));
    root.querySelector('[data-kind="once"]').setAttribute('data-selected', String(!state.abo));
    root.querySelector('[data-kind="abo"]').setAttribute('data-selected', String(state.abo));
    root.querySelector('[data-kind="once"]').setAttribute('aria-checked', String(!state.abo));
    root.querySelector('[data-kind="abo"]').setAttribute('aria-checked', String(state.abo));
    root.querySelector('.mmAOAboPrice').textContent = money(planPrice) + ' EUR';
    root.querySelector('.mmAOAboSub').textContent = '30 Sticks · ' + plan.deliveries +
      (plan.deliveries === 1 ? ' monatliche Lieferung' : ' monatliche Lieferungen');
    root.querySelector('.mmAOBadge').textContent = 'JEDEN MONAT ' + plan.discount + ' % SPAREN';
    root.querySelector('.mmAOSelectorValue').textContent = plan.title + ' · ' + plan.deliveries +
      (plan.deliveries === 1 ? ' Lieferung' : ' Lieferungen');
    var planButtons = root.querySelectorAll('.mmAOPlan');
    for (var i = 0; i < planButtons.length; i++) {
      planButtons[i].setAttribute('data-active', String(i === state.planIndex));
      planButtons[i].setAttribute('aria-pressed', String(i === state.planIndex));
    }
    applyPlan();
    buttonText();
  }

  function keyboardActivate(node, callback) {
    node.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      callback();
    });
  }

  function build(product) {
    if (document.getElementById('mmAboOriginal')) return true;
    if (isSetPage(product.title)) return true;
    var location = placementParent();
    var form = mainForm();
    if (!location || !form) return false;

    var rawPlans = [];
    (product.selling_plan_groups || []).forEach(function (group) {
      rawPlans = rawPlans.concat(group.selling_plans || []);
    });
    var seenMonths = {};
    var plans = rawPlans.map(planData).filter(function (plan) {
      if (!plan.id || !plan.termPlan || [1, 2, 3, 4, 5, 6, 12].indexOf(plan.months) === -1) return false;
      if (seenMonths[plan.months]) return false;
      seenMonths[plan.months] = true;
      return true;
    }).sort(function (a, b) { return a.months - b.months; });
    if (!plans.length) return true;

    state.product = product;
    state.plans = plans;
    style();
    var stickUrl = assetBase() + 'mm-abo-stick-' + productKey(product.title) + '.png';
    var basePrice = product.variants[0].price / 100;
    var plansHtml = plans.map(function (plan, index) {
      var price = basePrice * (1 - plan.discount / 100);
      var badge = BADGES[plan.months] || '';
      return '<button type="button" class="mmAOPlan" data-index="' + index + '" data-months="' + plan.months + '"' +
        (badge ? ' data-badge="' + badge + '"' : '') + ' data-active="' + (index === 0) + '" aria-pressed="' +
        (index === 0) + '"><strong class="mmAOPlanTitle">' + plan.title + '</strong>' +
        '<span class="mmAOPlanDiscount"><b>' + rollNumberMarkup(plan.discount, index) + '<span class="mmAOPercentSign">&thinsp;%</span></b> sparen</span>' +
        '<span class="mmAOPlanMeta">30 Sticks · ' + plan.deliveries +
        (plan.deliveries === 1 ? ' Lieferung' : ' Lieferungen') + '</span>' +
        '<span class="mmAOPlanPrice">' + money(price) + ' EUR · ' + (plan.deliveries * 30) + ' gesamt</span></button>';
    }).join('');

    var root = document.createElement('section');
    root.id = 'mmAboOriginal';
    root.setAttribute('data-open', 'false');
    root.setAttribute('aria-label', 'Kaufoptionen');
    root.innerHTML =
      '<div class="mmAOHeading"><h2>Wähle deine Kaufoption</h2></div>' +
      '<div class="mmAOCards" role="radiogroup" aria-label="Kaufoption wählen">' +
        '<div class="mmAOCard" data-kind="once" data-selected="true" role="radio" aria-checked="true" tabindex="0">' +
          '<div class="mmAOCardMain"><div class="mmAOSticks"><img class="mmAOStick" src="' + stickUrl + '" alt="" loading="lazy"></div>' +
          '<div><strong class="mmAOName">Einmaliger Kauf</strong><span class="mmAOPrice">' +
          money(basePrice) + ' EUR</span></div></div></div>' +
        '<div class="mmAOCard" data-kind="abo" data-selected="false" role="radio" aria-checked="false" tabindex="0">' +
          '<div class="mmAOCardMain"><span class="mmAOBadge"></span><div class="mmAOSticks">' +
            '<img class="mmAOStick" src="' + stickUrl + '" alt="" loading="lazy">' +
            '<img class="mmAOStick" src="' + stickUrl + '" alt="" loading="lazy">' +
            '<img class="mmAOStick" src="' + stickUrl + '" alt="" loading="lazy"></div>' +
          '<div><strong class="mmAOName">Monatsvorrat im Abo</strong><span class="mmAOPrice mmAOAboPrice"></span>' +
          '<span class="mmAOSub mmAOAboSub"></span></div></div>' +
          '<button type="button" class="mmAOSelector" aria-expanded="false">' +
            '<span class="mmAOSelectorTitle">Vorrat wählen</span><span class="mmAOSelectorValue"></span>' +
            '<span class="mmAOChevron" aria-hidden="true"></span></button>' +
          '<div class="mmAOPanelWrap"><div class="mmAOPanelClip"><div class="mmAOPanel" aria-label="Abo-Laufzeit auswählen">' +
            plansHtml + '</div></div></div>' +
        '</div>' +
      '</div>' +
      '<p class="mmAONote">Die gewählte Laufzeit umfasst die angezeigte Anzahl monatlicher Lieferungen und endet danach automatisch. Gesetzliche Rechte bleiben unberührt.</p>';

    location.parent.insertBefore(root, location.before);

    var onceCard = root.querySelector('[data-kind="once"]');
    var aboCard = root.querySelector('[data-kind="abo"]');
    var selector = root.querySelector('.mmAOSelector');
    var numberAnimationTimer = 0;
    function animatePlanNumbers(open) {
      window.clearTimeout(numberAnimationTimer);
      if (!open) {
        numberAnimationTimer = window.setTimeout(function () {
          root.classList.remove('mmAOPopPercents');
        }, 390);
        return;
      }
      root.classList.remove('mmAOPopPercents');
      void root.offsetWidth;
      numberAnimationTimer = window.setTimeout(function () {
        if (state.open && root.isConnected) root.classList.add('mmAOPopPercents');
      }, 70);
    }
    function selectOnce() {
      state.abo = false;
      state.open = false;
      selector.setAttribute('aria-expanded', 'false');
      render();
      animatePlanNumbers(false);
    }
    function selectAbo() {
      state.abo = true;
      render();
    }
    onceCard.querySelector('.mmAOCardMain').addEventListener('click', selectOnce);
    aboCard.querySelector('.mmAOCardMain').addEventListener('click', selectAbo);
    keyboardActivate(onceCard, selectOnce);
    keyboardActivate(aboCard, selectAbo);
    selector.addEventListener('click', function (event) {
      event.stopPropagation();
      state.abo = true;
      state.open = !state.open;
      selector.setAttribute('aria-expanded', String(state.open));
      render();
      animatePlanNumbers(state.open);
    });
    var planButtons = root.querySelectorAll('.mmAOPlan');
    for (var p = 0; p < planButtons.length; p++) {
      planButtons[p].addEventListener('click', function () {
        state.planIndex = parseInt(this.getAttribute('data-index'), 10) || 0;
        state.abo = true;
        render();
      });
    }

    if ('IntersectionObserver' in window) {
      shineObserver = new IntersectionObserver(function (entries) {
        root.classList.toggle('mmAOSeen', entries[0].isIntersecting && !document.hidden);
      }, { threshold: 0.2 });
      shineObserver.observe(root);
    } else {
      root.classList.add('mmAOSeen');
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) root.classList.remove('mmAOSeen');
    });

    form.addEventListener('submit', function () {
      applyPlan();
      var field = ensureSellingPlanField();
      if (field && state.abo && !field.disabled) form.appendChild(field);
    }, true);
    render();
    return true;
  }

  function holdPosition() {
    var root = document.getElementById('mmAboOriginal');
    if (!root) return;
    labelFlavors();
    var location = placementParent();
    if (location && root.parentNode === location.parent && root.previousElementSibling !== flavorAnchor()) {
      location.parent.insertBefore(root, location.before);
    }
    hideDuplicateWidgets();
    applyPlan();
    buttonText();
  }

  function start() {
    var labelAttempts = 0;
    var labelTimer = window.setInterval(function () {
      labelAttempts++;
      if (labelFlavors() || labelAttempts > 60) window.clearInterval(labelTimer);
    }, 250);
    labelFlavors();
    var path = window.location.pathname.replace(/\/$/, '');
    fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (!product) return;
        var attempts = 0;
        var timer = window.setInterval(function () {
          attempts++;
          if (build(product) || attempts > 60) {
            window.clearInterval(timer);
            if (document.getElementById('mmAboOriginal')) {
              window.clearInterval(holdTimer);
              holdTimer = window.setInterval(holdPosition, 1800);
              holdPosition();
            }
          }
        }, 250);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
